var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocuments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_52270)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_667_52270)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.1328,
    y: 15.5859,
    width: 35.7587,
    height: 38.1426,
    fill: "url(#pattern0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M28.4942 22.1836H25.167L11.8594 59.2357V77.7624C11.8594 80.5527 14.0929 82.8145 16.8502 82.8145H83.387C86.1444 82.8145 88.3779 80.5527 88.3779 77.7624V59.2357L75.0703 22.1836H71.743",
    stroke: "#39546A",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1856 51.8409V47.8867H25.0527V51.8409",
    stroke: "#39546A",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9086 39.9776V36.0234H30.3301V39.9776",
    stroke: "#39546A",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6317 28.1143V24.1602H35.6074V28.1143",
    stroke: "#39546A",
    strokeWidth: 2.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.375 59.0449H61.2779C59.8479 63.5639 55.3915 66.8586 50.1172 66.8586C44.8429 66.8586 40.3865 63.5639 38.9565 59.0449H11.8594",
    stroke: "#39546A",
    strokeWidth: 2.8,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_667_52270",
    transform: "scale(0.0333333 0.03125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_52270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 77,
    fill: "white",
    transform: "translate(3 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_667_52270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.0341,
    height: 41.0571,
    fill: "white",
    transform: "translate(8.51953 12.125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_667_52270",
    width: 30,
    height: 32,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/Documents.4229a5f2c8ec58a72e5dfe2a182456d4.svg";
export { ForwardRef as ReactComponent };